import { IFramework, IWebServiceManager, HttpMethod, IWebServiceRequest } from '@truckdown/framework';
import { IAccountData } from './IAccountData';
import { BasicAccountInfoModel } from "./BasicAccountInfoModel";


class AccountData implements IAccountData {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    private internalGetAccountInfo(request: IWebServiceRequest): Promise<BasicAccountInfoModel | null> {
        return new Promise<BasicAccountInfoModel | null>((resolve, reject) => {
            this.manager
                .get<BasicAccountInfoModel | null>(request)
                .then((res) => {
                    resolve((res as BasicAccountInfoModel));
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    getAccountInfo(accountId: string | number): Promise<BasicAccountInfoModel | null> {

        return this.internalGetAccountInfo(this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/get-account-info/' + encodeURIComponent(accountId),
            method: HttpMethod.GET
        }));
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<IAccountData>('IAccountData', (frm) => {
        return new AccountData(frm);
    });
}
